/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Pricing_TitleInputs */

const en_st_pricing_title = /** @type {(inputs: St_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const id_st_pricing_title = /** @type {(inputs: St_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

/**
* | output |
* | --- |
* | "Studio" |
*
* @param {St_Pricing_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_pricing_title = /** @type {((inputs?: St_Pricing_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Pricing_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_pricing_title(inputs)
	return en_st_pricing_title(inputs)
});